// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"38891e8d","838":"feac83d9"}[chunkId] + ".js";
};